module.exports = __webpack_public_path__ + "static/media/nb_akademie_bold-webfont.7bf1e67a.ttf";